module.exports = __webpack_public_path__ + "img/icon-19.a4a227ab.png";